export default __webpack_public_path__ + "static/media/laptop.dbe95901.svg";